import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'

const ChatParticipantsFormView = ({
  classes,
  children,
  onItemAdd,
  searchComponent,
}) => {
  return (
    <section className={classes.wrapper}>
      <div className={classes.formWrapper}>
        <span
          className={classes.title}
          cypress_id={'searchParticipantsInputTitle'}
        >
          Participants:
        </span>
        {searchComponent}
      </div>
      <div className={classes.itemsBlock}>{children}</div>
    </section>
  )
}

ChatParticipantsFormView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatParticipantsFormView)
